// The generic English alternate (e.g. /eu/en/) serves visitors without a matching locale.
const X_DEFAULT_HREFLANG = 'en';

/**
 * Resolve the x-default alternate from a page's hreflang alternates.
 * Points at the same page's generic English alternate, so it resolves to an existing,
 * indexable URL with return links (unlike the site root, which redirects by geo/cookie).
 *
 * @param {Array<{rel: string, hreflang: string, href: string}>} alternates
 * @return {{rel: string, hreflang: string, href: string}|null}
 */
export const resolveXDefault = alternates => {
    const alternate = alternates.find(({ hreflang }) => hreflang === X_DEFAULT_HREFLANG);

    return alternate ? { rel: 'alternate', hreflang: 'x-default', href: alternate.href } : null;
};
